import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BlockRender = _resolveComponent("BlockRender")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blocks, (block, ix) => {
      return (_openBlock(), _createBlock(_component_BlockRender, {
        key: _ctx.blockKey(block, ix),
        block: block,
        "is-first-block": ix === 0,
        parent: _ctx.parent,
        class: _normalizeClass({'o-tile-wrapper': !_ctx.nested, 'o-tile-wrapper--half': !_ctx.nested && _ctx.halfWidthTile(block)})
      }, null, 8, ["block", "is-first-block", "parent", "class"]))
    }), 128))
  ]))
}